var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.isLoading
        ? _c("div", { attrs: { id: "loader-wrapper" } }, [
            _c("div", { attrs: { id: "loader" } })
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("transition", { attrs: { name: "fade" } }, [
        _vm.success
          ? _c("div", [
              _c("div", { staticClass: "hero-subheader" }, [
                _c("div", { staticClass: "container" }, [
                  _c("div", { staticClass: "row" }, [
                    _c("div", { staticClass: "col-md-12" }, [
                      _c(
                        "div",
                        {
                          staticClass: "align-container",
                          attrs: { "data-mh": "" }
                        },
                        [
                          _c("div", { staticClass: "align-inner" }, [
                            _c(
                              "h1",
                              {
                                staticClass: "hero-subheader__title text-center"
                              },
                              [
                                _vm._v(
                                  "\n                    Muito Obrigado!\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "hero-subheader__desc text-center"
                              },
                              [
                                _vm._v(
                                  "\n                    Sua sugestão foi registrada com\n                    sucesso.\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "p",
                              {
                                staticClass: "hero-subheader__desc text-center"
                              },
                              [
                                _vm._v(
                                  "\n                    Para registrar uma nova entrada, "
                                ),
                                _c(
                                  "a",
                                  {
                                    attrs: { href: "#" },
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        return _vm.window.location.reload()
                                      }
                                    }
                                  },
                                  [_vm._v("clique aqui")]
                                ),
                                _vm._v(
                                  " ou recarregue essa página.\n                  "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("p", { staticClass: "text-center" }, [
                              _c("small", [
                                _vm._v("Para outros dados do levantamento, "),
                                _c(
                                  "a",
                                  {
                                    attrs: {
                                      href: "https://www.atlas.jor.br/equipe"
                                    }
                                  },
                                  [_vm._v("clique\n                      aqui")]
                                )
                              ])
                            ])
                          ])
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      !_vm.success
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c("media-suggestion-form", {
                    attrs: { "media-form-data": _vm.mediaForm },
                    model: {
                      value: _vm.mediaForm,
                      callback: function($$v) {
                        _vm.mediaForm = $$v
                      },
                      expression: "mediaForm"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-md-12" },
                [
                  _c("media-form", {
                    attrs: { "media-data": _vm.media },
                    on: {
                      startAjax: function($event) {
                        return _vm.setLoadingState(true)
                      },
                      endAjax: function($event) {
                        return _vm.setLoadingState(false)
                      }
                    },
                    model: {
                      value: _vm.media,
                      callback: function($$v) {
                        _vm.media = $$v
                      },
                      expression: "media"
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-md-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-atlas",
                    attrs: { type: "button" },
                    on: { click: _vm.sendForm }
                  },
                  [_vm._v("\n          Enviar\n        ")]
                )
              ])
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }